// Module-level store for the Lexical editor reference.
// Used to pass the editor to popovers rendered outside the LexicalComposer tree
// without going through Redux (which can't handle non-serializable objects).
let _editor = null;

export function setPageEditor(editor) {
  _editor = editor;
}

export function getPageEditor() {
  return _editor;
}
